import { render, staticRenderFns } from "./VuePersianDatetimePickerWithWeek.vue?vue&type=template&id=94f2b4e6&"
import script from "./VuePersianDatetimePickerWithWeek.vue?vue&type=script&lang=js&"
export * from "./VuePersianDatetimePickerWithWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports